import { render } from "./ProductSubfour.vue?vue&type=template&id=7f289d47&scoped=true"
import script from "./ProductSubfour.vue?vue&type=script&lang=js"
export * from "./ProductSubfour.vue?vue&type=script&lang=js"

import "./ProductSubfour.vue?vue&type=style&index=0&id=7f289d47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f289d47"]])

export default __exports__